import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../Icon';

import './style.scss';

function PageHeader({ title, hasBack = false, children = null }) {
  const navigate = useNavigate();
  return (
    <div className='page-header'>
      <Icon
        iconName='back-arrow'
        render={!!hasBack}
        onClick={() => {
          navigate(-1);
        }}
      />
      <h1>{title}</h1>
      {children}
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  hasBack: PropTypes.bool,
  children: PropTypes.node
};

export default PageHeader;
